import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './KeyFigures.css';

export default function KeyFigures() {
  const { t } = useLanguage();
  const k = t.keyFigures;

  return (
    <section className="key-figures" id="key-figures">
      <div className="key-figures-glow" aria-hidden="true" />
      <div className="container key-figures-inner">
        <header className="key-figures-head">
          <h2>{k.title}</h2>
          <p>{k.intro}</p>
        </header>

        <ul className="key-figures-grid">
          {k.items.map((item, i) => (
            <li key={item.label} className="key-figure" style={{ '--kf-i': i }}>
              <span className="key-figure-value">{item.value}</span>
              <span className="key-figure-label">{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
